import { createScaleTrichords } from './createScaleTrichords'
import { intervalFromInteger } from './intervals'

const scales = [
  [["Chromatic"],  [1, 101, 2, 102, 3, 4, 104, 5, 105, 6, 106, 7]],
  [["Major Chord"],  [1, 3, 5]],
  [["Major 7th Chord"], [1, 3, 5, 7]],
  [["Dominant 7th Chord"], [1, 3, 5, -7]],
  [["Minor Chord"], [1, -3, 5]],
  [["Minor 7th Chord"], [1, -3, 5, -7]],
  [["Diminished 7th Chord"], [1, -3, -5, -107]],
  [["Augmented 7th Chord"], [1, 3, 105, -7]],
  [["Major"], [1, 2, 3, 4, 5, 6, 7]],
  [
    ["Major Pentatonic", "Mongolian"],
    [1, 2, 3, 5, 6]
  ],
  [["Major Pentatonic Blues"], [1, 2, -3, 3, 5, 6]],
  [["Scottish Pentatonic"], [1, 2, 4, 5, 6]],
  [
    ["Suspended Pentatonic", "Egyptian"],
    [1, 2, 4, 5, -7]
  ],
  [["Harmonic Major"], [1, 2, 3, 4, 5, -6, 7]],
  [
    ["Double Harmonic", "Byzantine", "Arabic"],
    [1, -2, 3, 4, 5, -6, 7]
  ],
  [["Minor"], [1, 2, -3, 4, 5, -6, -7]],
  [["Minor Pentatonic"], [1, -3, 4, 5, -7]],
  [["Minor Pentatonic Blues"], [1, -3, 4, -5, 5, -7]],
  [["Minor 6th Pentatonic"], [1, -3, 4, 5, 6]],
  [["Harmonic Minor"], [1, 2, -3, 4, 5, -6, 7]],
  [["Melodic Minor Ascending"], [1, 2, -3, 4, 5, 6, 7]],
  [["Melodic Minor Descending"], [1, -7, -6, 5, 4, -3, 2, 1]],
  [["Ionian"], [1, 2, 3, 4, 5, 6, 7]],
  [["Dorian"], [1, 2, -3, 4, 5, 6, -7]],
  [["Phrygian"], [1, -2, -3, 4, 5, -6, -7]],
  [["Phrygian Dominant"], [1, -2, 3, 4, 5, -6, -7]],
  [["Lydian"], [1, 2, 3, 104, 5, 6, 7]],
  [
    ["Lydian Dominant", "Acoustic"],
    [1, 2, 3, 104, 5, 6, -7]
  ],
  [["Aeolian"], [1, 2, -3, 4, 5, -6, -7]],
  [["Mixolydian"], [1, 2, 3, 4, 5, 6, -7]],
  [["Mixolydian Flat-6"], [1, 2, 3, 4, 5, -6, -7]],
  [["Locrian"], [1, -2, -3, 4, -5, -6, -7]],
  [
    ["Locrian Natural-2", "Half-Diminished"],
    [1, 2, -3, 4, -5, -6, -7]
  ],
  [
    ["Super Locrian", "Altered scale"],
    [1, -2, -3, -4, -5, -6, -7]
  ],
  [["Enigmatic Major"], [1, -2, 3, 104, 105, 106, 7]],
  [["Enigmatic Minor"], [1, -2, -3, 104, 5, 106, 7]],
  [["Diminished Whole-Half"], [1, 2, -3, 4, -5, -6, 6, 7]],
  [["Diminished Half-Whole"], [1, -2, -3, -4, -5, 5, 6, -7]],
  [["Whole Tone"], [1, 2, 3, 104, 105, -7]],
  [["Augmented"], [1, -3, 3, 5, 105, 7]],
  [["Dominant 7th"], [1, 2, 4, 5, 6, -7]],
  [
    ["Prometheus", "Mystic"],
    [1, 2, 3, 104, 6, -7]
  ],
  [["Overtone"], [1, 2, 3, 104, 5, 6, -7]],
  [["Leading Tone"], [1, 2, 3, 104, -6, -7, 7]],
  [["Bebop Major"], [1, 2, 3, 4, 5, 105, 6, 7]],
  [["Bebop Minor"], [1, 2, -3, 3, 4, 5, 6, -7]],
  [["Bebop Dominant"], [1, 2, 3, 4, 5, 6, -7, 7]],
  [["Neapolitan Major"], [1, -2, -3, 4, 5, 6, 7]],
  [["Neapolitan Minor"], [1, -2, -3, 4, 5, -6, 7]],
  [["Hungarian Major"], [1, 102, 3, 104, 5, 6, -7]],
  [["Hungarian Minor"], [1, 2, -3, 104, 5, -6, 7]],
  [["Hungarian Gypsy"], [1, 2, -3, 104, 5, -6, -7]],
  [["Spanish"], [1, -2, -3, 3, -5, -6, -7]],
  [
    ["Spanish Eight Tone", "Jewish Eight Tone"],
    [1, -2, -3, 3, 4, -5, -6, -7]
  ],
  [["Spanish Gypsy"], [1, -2, 3, 4, 5, -6, -7]],
  [["Hirajoshi"], [1, 2, -3, 5, -6]],
  [["Japanese A"], [1, -2, 4, -5, 6]],
  [["Japanese B"], [1, 2, 4, -5, 6]],
  [["Yo"], [1, 2, 4, 5, 6, -7]],
  [["Insen"], [1, -2, 4, 5, -7]],
  [["Iwato"], [1, -2, 4, -5, -7]],
  [["Oriental"], [1, -2, 3, 4, -5, 6, -7]],
  [["Persian"], [1, -2, 3, 4, -5, -6, 7]],
  [["Arabian"], [1, 2, 3, 4, 104, 105, -7]],
  [["Balinese"], [1, -2, -3, 5, -6]],
  [["Kumoi"], [1, 2, -3, 5, 6]],
  [["Pelog"], [1, -2, -3, 5, -6]],
  [["Algerian"], [1, 2, -3, 4, 104, 5, -6, 7]],
  [["Chinese"], [1, 104, 5, 7]],
  [["Romanian Major"], [1, -2, 3, 104, 5, 6, -7]],
  [["Romanian Minor"], [1, 2, -3, 104, 5, 6, -7]],
  [["Hindu"], [1, 2, 3, 4, 5, -6, -7]],
  [["Istrian"], [1, -2, -3, -4, -5, 5]],
  [["Ukrainian Dorian"], [1, 2, -3, 104, 5, 6, -7]]
]


import type { RawScale } from './types'

// https://github.com/Zachacious/MusicTheoryJS/blob/65572a7bf58e0485f250bd92748fdd1e975f4a90/src/scale/scaleTemplates.ts
// https://en.wikipedia.org/wiki/List_of_musical_scales_and_modes
// https://plucknplay.github.io/en/scale-list.html
// https://www.jazz-guitar-licks.com/pages/guitar-scales-modes/
// https://www.omnicalculator.com/other/music-scale
let scalesArray: RawScale[] = []

export function scalesFromJSON(): RawScale[] {
  return scales.map(val => {
    const names = val[0] as string[]
    const intervals = (val[1] as number[]).map(intervalFromInteger)
    const trichords = createScaleTrichords(intervals)
    return {
      names,
      intervals,
      trichords
    }
  })
}

export function findScale(scaleName: string): RawScale | undefined {
  if (scalesArray.length === 0) {
    scalesArray = scalesFromJSON()
  }
  const name = scaleName.replaceAll(/-|\s/g, '').toLowerCase().trim()
  return scalesArray.find(scl =>
    scl.names.find(n => n.replaceAll(/-|\s/g, '').trim().toLowerCase() === name)
  )
}
